<span class="tag-item" [ngClass]="[tag.tagTypeFromEntity == 'PRIVATE' ? 'privat-tag' : '', tag.tagTypeFromEntity == 'SYSTEM' ? 'system-tag' : '']">
{{tag.tagCode | translate}}
<ng-container *rlNoPrivileges="['RL_LEGANTO_GUEST']">
   <rl-remove-button *ngIf="tag.canRemove && !hideRemove" (onRemove)="remove()" [id]="'remove-' + uniqueId"></rl-remove-button>
</ng-container>
</span>